
import { Contact } from "@/models/base";
import { SupplierService } from "@/services";
import { IExcelMapperExtraData, PriceListProductService } from "@/services/price-list-product-service";
import { ProductCSVImportProductMatchingMethod } from "@/services/product-service";
import AppExcelMapper from "@/components/excel-mapper/ExcelMapper.vue";
import Vue from "vue";
import AppProductMatchingMethodSelect from "./ProductMatchingMethodSelect.vue";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseByID.vue";
import { ExcelMapperConfig } from "@/utils/excel-mapper/excel-mapper-config";

export default Vue.extend({
	data(){
		return {
			PriceListProductService,
			cols: [] as string[],
		};
	},
	methods: {
		async onExcelMapperFile(file:File, extraData:IExcelMapperExtraData){
			let productMatchingMethod = extraData.ProductMatchingMethod || ProductCSVImportProductMatchingMethod.SKU;
			let supplier:null | Contact = null;
			if (extraData.SupplierID){
				supplier = await SupplierService.getContact(extraData.SupplierID);
			}
			await PriceListProductService.importPriceListProductsExcel(file, productMatchingMethod, supplier);
		},
		setSupplierEmpty(settings:ExcelMapperConfig){
			settings.ExtraData.SupplierID = 0;
		}
	},
	async created(){
		let allowedCols = await PriceListProductService.allowedCols();
		this.cols = allowedCols.map(c=>{
			return c[1] || c[0];
		});
	},
	components: {
		AppExcelMapper,
		AppProductMatchingMethodSelect,
		AppContactSearch
	},
	i18nEx: {
		componentPrefix: "components.price-lists"
	}
});
